import { load } from '@/util/router-utils.js'

export default [
  {
    path: 'admin',
    component: load('app/client/admin/Index'),
    children: [
      {
        path: 'groups',
        component: load('app/client/admin/groups/Index')
      },
      {
        path: 'users',
        component: load('app/client/admin/users/Index')
      },
      {
        path: 'animal-types',
        component: load('app/client/admin/animal-types/Index')
      },
      {
        path: 'ingredient-types',
        component: load('app/client/admin/ingredient-types/Index')
      },
      {
        path: 'mixers',
        component: load('app/client/admin/mixers/Index'),
        children: [
          {
            path: 'companies/:company_id/farms/:farm_id',
            component: load('app/client/admin/mixers/Index'),
            props: true
          }
        ]
      },
      {
        path: 'blanks',
        component: load('app/client/admin/blanks/Index'),
        children: [
          {
            path: 'companies/:company_id/farms/:farm_id',
            component: load('app/client/admin/blanks/Index'),
            props: true
          }
        ]
      }
    ]
  }
]
